import {Component, inject} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatRadioModule} from "@angular/material/radio";

import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import {ScreeningRunSettings} from '../../models/screening-settings';
import {ScreeningRunExcludeFilter} from '../../dto/screening-process';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {CloseableDialogComponent} from "../../../../utils/components/closeable-dialog/closeable-dialog.component";

interface ExcludeList {
  value: ScreeningRunExcludeFilter,
  label: string
}

@Component({
  selector: 'app-screening-start-dialog',
    imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule,
    MatButtonModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSelectModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    CloseableDialogComponent
],
  templateUrl: './screening-start-dialog.component.html',
  styleUrl: './screening-start-dialog.component.scss'
})
export class ScreeningStartDialogComponent {
  private readonly fb: FormBuilder = inject(FormBuilder);
  private readonly dialogRef: MatDialogRef<ScreeningStartDialogComponent> = inject(MatDialogRef);

  form: FormGroup = this.fb.group({
    processFullText: [false, Validators.required],
    ignoreScreened: [false, Validators.required],
    minScore: [0.2, Validators.required],
    maxResults: [2, Validators.required],
    excludePapers: [''],
  });

  excludeList: ExcludeList[] = [
    {
      value: ScreeningRunExcludeFilter.NO_PDF,
      label: 'No PDF'
    }, {
      value: ScreeningRunExcludeFilter.NO_ABSTRACT,
      label: 'No abstract'
    }
  ];

  close(): void {
    this.dialogRef.close();
  }

  start(): void {
    const screeningRunSettings: ScreeningRunSettings = {
      ...this.form.value,
    }
    this.dialogRef.close(screeningRunSettings);
  }
}
